module.exports = __webpack_public_path__ + "img/组 2.270ee0f6.png";